import type { IFileUploadWithContent } from "@citrine/utils/s3";

import type { ICitrineUploadRequestResponse } from "./file";

const BUCKET_OWNER_FULL_CONTROL = "bucket-owner-full-control" as const;
const X_CITRINE_UPLOAD_ID = "Citrine-Upload-Id" as const;

export function uploadRequestResponseToS3Config(
  uploadRequestResponse: ICitrineUploadRequestResponse,
  fileUploadWithContent: IFileUploadWithContent,
) {
  const { s3_region, s3_bucket, temporary_credentials, uploads } =
    uploadRequestResponse;

  const { content, ...fileUpload } = fileUploadWithContent;
  const { uploadId } = fileUploadWithContent;

  const Key = uploads.find(({ upload_id }) => upload_id === uploadId)?.s3_key;

  return Key
    ? {
        config: {
          credentials: {
            accessKeyId: temporary_credentials.access_key_id,
            secretAccessKey: temporary_credentials.secret_access_key,
            sessionToken: temporary_credentials.session_token,
          },
          region: s3_region,
        },
        params: {
          Bucket: s3_bucket,
          Key,
          Body: content,
          ACL: BUCKET_OWNER_FULL_CONTROL, // probably want to change this
          ContentType:
            typeof content === "string" ? "text/plain" : content.type,
          Metadata: {
            [X_CITRINE_UPLOAD_ID]: uploadId,
          },
        },
        fileUpload,
      }
    : undefined;
}
